import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom, of, switchMap } from 'rxjs';
import { createFeatureStore } from '../../../utils/feature-store.util';
import { AccountType, AccountWiseRecords } from '@qid/core';
import { EntityState } from '@ngrx/entity';
import { AuthSelectors, setActiveAccount } from '../../authentication';
import { IntegrationConfigurationApi } from '../services/integration.api';
import { IntegrationConfiguration } from '../interface/integration-configuration.interface';

interface AdditionalAccountWiseData {
  integrations: IntegrationConfiguration[];
  timeConfigReady: boolean;
}

const initialAccountWiseDataState = {
  integrations: [],
  timeConfigReady: false,
};

export const IntegrationConfigurationStore =
  createFeatureStore<IntegrationConfiguration, EntityState<AccountWiseRecords<IntegrationConfiguration, AdditionalAccountWiseData>>>('account-profile');

@Injectable({
  providedIn: 'root'
})
export class IntegrationConfigurationFacade {

  private readonly apiService = inject(IntegrationConfigurationApi);

  public activeAccount$ = this.store.select(IntegrationConfigurationStore.selectors.selectActiveAccount);

  public integrationConfiguration$ = this.store.select(IntegrationConfigurationStore.selectors.selectActiveAccountAdditionalData).pipe(
    switchMap((data: AdditionalAccountWiseData) => {
      if (data) {
        return of(data.integrations);
      }
      return of(null);
    })
  );

  public timeConfigReady$ = this.store.select(IntegrationConfigurationStore.selectors.selectActiveAccountAdditionalData).pipe(
    switchMap((data: AdditionalAccountWiseData) => {
      if (data) {
        return of(data.timeConfigReady);
      }
      return of(false);
    })
  );

  constructor(private store: Store) {
    this.setAccountChangeListener();
  }

  setAccountChangeListener() {
    this.store.select(AuthSelectors.selectActiveAccount).subscribe(account => {
      if (account) {
        // this.init()
      }
    })
  }

  async init() {
    if (!await firstValueFrom(this.activeAccount$)) {
      await this.addAccount();
    }
  }

  private async addAccount() {

    const account_id = await firstValueFrom(this.store.select(AuthSelectors.selectActiveAccountId));
    if (!account_id) {
      return;
    }
    const accountType = await firstValueFrom(this.store.select(AuthSelectors.selectActiveAccountType));

    const accountBasedEntity: AccountWiseRecords<IntegrationConfiguration> = IntegrationConfigurationStore.createAccount(account_id, accountType, initialAccountWiseDataState);

    this.store.dispatch(IntegrationConfigurationStore.actions.addAccount({ accountBasedEntity: accountBasedEntity }));

  }

  async refresh() {
    const account_id = await firstValueFrom(this.store.select(AuthSelectors.selectActiveAccountId));
    this.store.dispatch(IntegrationConfigurationStore.actions.loadRecordsForAccount({
      account_id: account_id, accountType: AccountType.organisation
    }));
  }


  async removeConfig(configId: string) {
    const account_id = await firstValueFrom(this.store.select(AuthSelectors.selectActiveAccountId));
    await this.apiService.delete(configId);
    return this.refresh();
  }



}
